import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useUrlLocalizer } from 'tradera/lang/translate';
import utils from './rating-utils';
import RatingIcon from '@tradera/blueprint/theme/icons2/rating.svg?jsx';
import styles from './rating-stars.module.scss';

// Rating is multipled with 20.5 to account for margin between stars and rounding up
import ALink from 'tradera/components/alink/alink';

const RatingStars = ({
    memberAlias,
    memberId,
    rating,
    gaAttributes,
    link,
    dark = false,
    onClick
}) => {
    const { toLocalizedUrl } = useUrlLocalizer();
    const displayRating = utils.getDisplayRating(rating);

    const Stars = () => (
        <>
            <div
                className={styles.ratingStarsOverlay}
                style={{ width: `${rating * 20.5}%` }}>
                <RatingIcon
                    className={`icon icon-sm ${dark ? 'icon-dark' : ''}`}
                />
                <RatingIcon
                    className={`icon icon-sm ${dark ? 'icon-dark' : ''} ml-1`}
                />
                <RatingIcon
                    className={`icon icon-sm ${dark ? 'icon-dark' : ''} ml-1`}
                />
                <RatingIcon
                    className={`icon icon-sm ${dark ? 'icon-dark' : ''} ml-1`}
                />
                <RatingIcon
                    className={`icon icon-sm ${dark ? 'icon-dark' : ''} ml-1`}
                />
            </div>
            <div className={styles.ratingStarsBase}>
                <RatingIcon className="icon icon-sm" />
                <RatingIcon className="icon icon-sm ml-1" />
                <RatingIcon className="icon icon-sm ml-1" />
                <RatingIcon className="icon icon-sm ml-1" />
                <RatingIcon className="icon icon-sm ml-1" />
            </div>
        </>
    );
    return link ? (
        <Fragment>
            <div
                className={`${styles.ratingStars} d-flex ${
                    dark ? styles.dark : styles.light
                }`}>
                <ALink
                    className="position-relative"
                    href={toLocalizedUrl(
                        `/profile/feedback/${memberId}/${memberAlias}`
                    )}
                    {...gaAttributes}
                    useLink={true}
                    onClick={onClick}>
                    <Stars />
                </ALink>

                <div className={`${styles.ratingStars} ml-1 my-auto`}>
                    <a
                        href={toLocalizedUrl(
                            `/profile/feedback/${memberId}/${memberAlias}`
                        )}
                        {...gaAttributes}>
                        {displayRating}
                    </a>
                </div>
            </div>
        </Fragment>
    ) : (
        <Fragment>
            <div
                className={`${styles.ratingStars} d-flex ${
                    dark ? styles.dark : styles.light
                }`}>
                <div className="position-relative">
                    <Stars />
                </div>
                <div className="ml-1 my-auto">{displayRating}</div>
            </div>
        </Fragment>
    );
};

RatingStars.defaultProps = {};

RatingStars.propTypes = {
    memberAlias: PropTypes.string,
    memberId: PropTypes.number,
    rating: PropTypes.number,
    gaAttributes: PropTypes.object,
    dark: PropTypes.bool,
    link: PropTypes.bool
};

export default RatingStars;
